import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import type { SerializedError } from "@reduxjs/toolkit";

export type RequestError = FetchBaseQueryError | SerializedError;

export function statusOf(error: RequestError): number | undefined {
    return "status" in error && typeof error.status === "number" ? error.status : undefined;
}

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null;
}

export function serverMessageOf(error: RequestError): string | undefined {
    if (!("data" in error) || !isRecord(error.data) || !Array.isArray(error.data.errors)) {
        return undefined;
    }
    const [first]: unknown[] = error.data.errors;
    return isRecord(first) && typeof first.message === "string" && first.message !== "" ? first.message : undefined;
}

export function failureFor(error: RequestError, failures: Record<number, string>, otherwise: string): string {
    const status = statusOf(error);
    return (status !== undefined && failures[status]) || otherwise;
}
